import moment from 'moment'

moment.locale('fr')

let dataFormatter = {
  moneyCeil(value){
    return (Math.ceil(value * 100)/100)
  },
  moneyFloor(value){
    return (Math.floor(value * 100)/100)
  },
  moneyRound(value){
    return (Math.round(value * 100)/100)
  },
  formatMoney(value){
    return new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' }).format(value)
  },
  formatNumber(value){
    return new Intl.NumberFormat('fr-FR').format(value)
  },
  formatDuration(value){
    const hours = Math.floor(value)
    const minutes = Math.round((value - hours) * 60)
    const seconds = Math.round((value - hours - minutes/60) * 3600)
    let result = ""
    if (hours > 0) result += hours + 'h'
    if (minutes > 0) result += minutes + 'min'
    if (seconds > 0) result += seconds + 'sec'
    if (result === "") result = "0s"
    return result
  },
  formatDurationMinutes(value){
    const hours = Math.floor(value)
    const minutes = Math.round((value - hours) * 60)
    let result = ""
    if (hours > 0) result += hours + 'h'
    if (minutes > 0) result += minutes
    if (hours < 0) result += 'min'
    if (result === "") result = "0min"
    return result
  },
  formatAndRoundDuration(value){
    const hours = Math.floor(value)
    const minutes = Math.round((value - hours) * 60)
    let result = ""
    if (hours > 0) result += hours + 'h'
    if (minutes > 0) result += minutes + 'min'
    if (result === "") result = "0min"
    return result
  },
  /**
   * Score affiché.
   *
   * Un score est une note sur 100, toujours entière : le moteur les enregistre déjà
   * arrondis. Cette fonction reste le passage obligé de l'affichage pour que les états
   * calculés avant cette règle, qui portent encore des décimales, soient présentés de la
   * même façon partout — les écrans arrondissaient jusqu'ici tantôt vers le haut, tantôt
   * vers le bas, pour une même valeur.
   */
  formatScore(value){
    const score = Math.round(Number(value))
    return Number.isFinite(score) ? score : 0
  },
  formatRank(value){
    if (value === 1) return "1 er"
    else return value + " ème"
  }
}

export default dataFormatter